let mem = null;
let timer = null;

const DEFAULT_TTL_MS = Number(process.env.REACT_APP_2FA_CREDS_TTL_MS || 10 * 60 * 1000);

export function set2faCreds({ username, password, ttlMs = DEFAULT_TTL_MS }) {
  clear2faCreds();
  mem = { username, password, expiresAt: Date.now() + ttlMs };
  timer = setTimeout(() => {
    clear2faCreds();
  }, ttlMs);
}

export function get2faCreds() {
  if (!mem) return null;
  if (Date.now() > mem.expiresAt) {
    clear2faCreds();
    return null;
  }
  return { username: mem.username, password: mem.password };
}

export function clear2faCreds() {
  mem = null;
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
}

// Limpia al cerrar/recargar pestaña
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    clear2faCreds();
  });
}